import script from "./AuthorInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorInfo.vue?vue&type=script&setup=true&lang=js"

import "./AuthorInfo.vue?vue&type=style&index=0&id=d8fddd22&lang=scss"

const __exports__ = script;

export default __exports__